// extracted by mini-css-extract-plugin
export default {"section":"ProjectExamples_section__0Ad0e","container":"ProjectExamples_container__yh0G0","swiper":"ProjectExamples_swiper__8q-V5","slide":"ProjectExamples_slide__gDoJc"};